import { MODE_CATEGORY } from '../types/modeCategory';

export type CategoryOption = { label: string; value: string };

/** Mode Category dropdown options — pure catalog labels for `MODE_CATEGORY`'s values. */
export const MODE_CATEGORY_OPTIONS_BASIC: CategoryOption[] = [
  { label: '', value: MODE_CATEGORY.NONE },
  { label: 'Manual', value: MODE_CATEGORY.MANUAL },
  { label: 'Auto', value: MODE_CATEGORY.AUTO },
  { label: 'Panel Control', value: MODE_CATEGORY.PANEL_CONTROL },
  { label: 'Dual Tank', value: MODE_CATEGORY.DUAL_TANK },
  { label: 'Master Tank', value: MODE_CATEGORY.MASTER_TANK },
  { label: 'Constant Flow', value: MODE_CATEGORY.CONSTANT_FLOW },
  { label: 'Constant Pressure', value: MODE_CATEGORY.CONSTANT_PRESSURE },
  { label: 'CIP', value: MODE_CATEGORY.CIP },
  { label: 'CEB', value: MODE_CATEGORY.CEB },
  { label: 'Sterilization', value: MODE_CATEGORY.STERILIZATION },
  { label: 'Legacy Control', value: MODE_CATEGORY.LEGACY_CONTROL },
];

/** Adds Storm Mode — offered only when the row's controller is itself a storm-mode controller. */
export const MODE_CATEGORY_OPTIONS_EXTENDED: CategoryOption[] = [
  ...MODE_CATEGORY_OPTIONS_BASIC,
  { label: 'Storm Mode', value: MODE_CATEGORY.STORM_MODE },
];
